let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("96f52")).then(() => parcelRequire('irpMW'));